import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  DialogPortal,
} from "@mozioinc/ui";
import { useSearch } from "@tanstack/react-router";
import { SearchForm } from "./search-form";

const SearchDialog = Dialog;
const SearchDialogTrigger = DialogTrigger;

type SearchDialogContentProps = {
  onSubmit?: () => void;
};

const SearchDialogContent = ({ onSubmit }: SearchDialogContentProps) => {
  const { arrivalDateTime, departureDateTime, location } = useSearch({
    from: "/search",
  });

  return (
    <DialogPortal className="items-start pt-[calc(var(--mz-header-height,3.25rem)+1rem)]">
      <DialogContent className="bg-neutral-100 p-3 md:p-5 lg:max-w-5xl">
        <DialogClose />
        <SearchForm
          onSubmit={onSubmit}
          defaultArrivalDateTime={arrivalDateTime}
          defaultDepartureDateTime={departureDateTime}
          defaultLocation={location}
        />
      </DialogContent>
    </DialogPortal>
  );
};

export { SearchDialog, SearchDialogContent, SearchDialogTrigger };
